import { FC, useState } from "react";

import {
  MuiButtonPrimary,
  MuiButtonSecondary,
  MuiModal,
  MuiTypography,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  CreateProgramTemplateFooterWrapper,
  DiscardMessageWrapper,
} from "./CreateProgramTemplateFooter.style";
interface CreateProgramTemplateFooterProps {
  pageId: string;
  onConfirmClick: () => void;
  handleNavigateBack: () => void;
  isFiledUpdated: boolean;
  confirmButtonLabel: string;
  cancelButtonLabel: string;
}

export const CreateProgramTemplateFooter: FC<
  CreateProgramTemplateFooterProps
> = ({
  pageId,
  onConfirmClick,
  handleNavigateBack,
  isFiledUpdated,
  confirmButtonLabel,
  cancelButtonLabel,
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { commonLabels } = useSiteCore();

  const handleModalClose = () => {
    setShowConfirmationModal(false);
  };

  const onCancelButton = () => {
    isFiledUpdated ? setShowConfirmationModal(true) : handleNavigateBack();
  };

  const handleOkClick = () => {
    handleModalClose();
    handleNavigateBack();
  };

  return (
    <CreateProgramTemplateFooterWrapper>
      <MuiButtonSecondary id={`${pageId}-cancel`} onClick={onCancelButton}>
        {cancelButtonLabel}
      </MuiButtonSecondary>
      <MuiButtonPrimary onClick={onConfirmClick} id={`${pageId}-confirm`}>
        {confirmButtonLabel}
      </MuiButtonPrimary>
      {showConfirmationModal && (
        <MuiModal
          open={showConfirmationModal}
          onClose={handleModalClose}
          title={commonLabels.confirmation}
          primaryButtonTitle={commonLabels.yes}
          secondaryButtonTitle={commonLabels.no}
          onPrimaryButtonClick={handleOkClick}
          onSecondaryButtonClick={handleModalClose}
        >
          <DiscardMessageWrapper>
            <MuiTypography
              id="modal-description"
              variant="h3"
              className="confirm-message"
            >
              {commonLabels.discardChangesGivenInfoWillLostText}
            </MuiTypography>
          </DiscardMessageWrapper>
        </MuiModal>
      )}
    </CreateProgramTemplateFooterWrapper>
  );
};
